var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import DateFnsUtils from '@date-io/date-fns';
import format from 'date-fns/format';
import frLocale from 'date-fns/locale/fr';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateInputCss from './css/DateInputCss';
import moment from 'moment';
import { withStyles } from '@material-ui/core';

var FrDateFnsUtils = function (_DateFnsUtils) {
  _inherits(FrDateFnsUtils, _DateFnsUtils);

  function FrDateFnsUtils() {
    _classCallCheck(this, FrDateFnsUtils);

    return _possibleConstructorReturn(this, _DateFnsUtils.apply(this, arguments));
  }

  FrDateFnsUtils.prototype.startOfMonth = function startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  };

  FrDateFnsUtils.prototype.getDatePickerHeaderText = function getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', {
      locale: this.locale
    });
  };

  return FrDateFnsUtils;
}(DateFnsUtils);

var DateInput = function (_Component) {
  _inherits(DateInput, _Component);

  function DateInput() {
    var _temp, _this2, _ret;

    _classCallCheck(this, DateInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this2), _this2.state = {}, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = _extends({}, prevState);

    if (nextProps.name && nextProps.value !== prevState[nextProps.name]) {
      var _extends2;

      newState = _extends({}, newState, (_extends2 = {}, _extends2[nextProps.name] = nextProps.value, _extends2.dateValue = new Date(nextProps.value), _extends2));
    }

    return newState;
  };

  DateInput.prototype.getErrorMessage = function getErrorMessage(name) {
    var collectionStore = this.props.collectionStore;

    if (collectionStore.errors && collectionStore.errors[name]) {
      return collectionStore.errors[name].map(function (err, index) {
        return React.createElement('span', {
          style: {
            display: 'block'
          },
          key: index
        }, err);
      });
    } else {
      return null;
    }
  };

  DateInput.prototype.onChangeHandler = function onChangeHandler(name, date) {
    var _setState;

    var isoDate = date ? format(date, 'yyyy-MM-dd') : null;
    this.setState((_setState = {}, _setState[name] = isoDate, _setState.dateValue = date, _setState));
    var fakeEvent = {
      target: {
        value: isoDate
      }
    };
    this.props.onChangeHandler(name, fakeEvent);
  };

  DateInput.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        collectionStore = _props.collectionStore,
        name = _props.name,
        value = _props.value,
        format = _props.format;
    var dateValue = this.state.dateValue;
    var filteredProps = ['name', 'collectionStore', 'onChangeHandler', 'value'];
    var inputProps = Object.keys(this.props).filter(function (k) {
      return !filteredProps.includes(k);
    }).reduce(function (obj, key) {
      obj[key] = _this3.props[key];
      return obj;
    }, {});
    var error = !!collectionStore.errors && !!collectionStore.errors[name];
    return React.createElement(MuiPickersUtilsProvider, {
      locale: frLocale,
      utils: FrDateFnsUtils
    }, React.createElement(DatePicker, _extends({
      cancelLabel: 'Annuler',
      error: error,
      format: !!format ? format : "d MMMM yyyy",
      helperText: this.getErrorMessage(name),
      invalidLabel: '',
      leftArrowIcon: React.createElement(ChevronLeft, null),
      okLabel: 'Valider',
      onChange: this.onChangeHandler.bind(this, name),
      rightArrowIcon: React.createElement(ChevronRight, null),
      value: value ? dateValue : '',
      clearable: true,
      clearLabel: 'Vider'
    }, inputProps)));
  };

  return DateInput;
}(Component);

export default withStyles(DateInputCss)(DateInput);